export function isDateInSeason({
  date,
  season
}) {
  if (!date || !season) {
    return false
  }

  const currentDate =
    date instanceof Date
      ? new Date(
          date.getFullYear(),
          date.getMonth(),
          date.getDate()
        )
      : new Date(date)

  if (Number.isNaN(currentDate.getTime())) {
    return false
  }

  const month = currentDate.getMonth() + 1
  const day = currentDate.getDate()

  const startMonth = Number(season.start_month)
  const startDay = Number(season.start_day)
  const endMonth = Number(season.end_month)
  const endDay = Number(season.end_day)

  if (
    !startMonth ||
    !startDay ||
    !endMonth ||
    !endDay
  ) {
    return false
  }

  const currentValue =
    month * 100 + day

  const startValue =
    startMonth * 100 + startDay

  const endValue =
    endMonth * 100 + endDay

  // Normal season:
  // Example: Summer = Jun 21 → Sep 21
  if (startValue <= endValue) {
    return (
      currentValue >= startValue &&
      currentValue <= endValue
    )
  }

  // Wraparound season:
  // Example: Winter = Dec 21 → Mar 19
  return (
    currentValue >= startValue ||
    currentValue <= endValue
  )
}